export const DOMReady = (cb) => {
    if (document.readyState !== "complete") {
        document.addEventListener("readystatechange", cb);
        return;
    }
};
